import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { StoreProvider, useStore } from "./store";
import Header from "./components/Header";
import PageWrapper from "./components/PageWrapper";
import Home from "./pages/Home";
import Welcome from "./pages/Welcome";
import Category from "./pages/Category";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import MyOrders from "./pages/MyOrders";
import SearchResults from "./pages/SearchResults";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

function Shell() {
  const { welcomed } = useStore();
  const location = useLocation();
  // Admin pages always accessible without welcome gate
  if (location.pathname.startsWith("/admin") || welcomed) {
    // fall through to main app
  }
  if (!welcomed && !location.pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="*" element={<Welcome />} />
      </Routes>
    );
  }
  return (
    <>
      <Header />
      <PageWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/benvenuto" element={<Welcome />} />
          <Route path="/categoria/:slug" element={<Category />} />
          <Route path="/prodotto/:id" element={<ProductDetail />} />
          <Route path="/carrello" element={<Cart />} />
          <Route path="/i-miei-ordini" element={<MyOrders />} />
          <Route path="/cerca" element={<SearchResults />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </PageWrapper>
    </>
  );
}

function App() {
  const content = (
    <StoreProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster richColors />
    </StoreProvider>
  );
  return (
    <div className="App bg-[#FAF7F2]">
      {GOOGLE_CLIENT_ID ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{content}</GoogleOAuthProvider> : content}
    </div>
  );
}

export default App;
